export const GET_GEO_REPORTS = 'GET_GEO_REPORTS';
export const GET_GEO_REPORT = 'GET_GEO_REPORT';
export const GET_GEO_REPORT_STATUS = 'GET_GEO_REPORT_STATUS';
export const GET_GEO_REPORT_USAGE = 'GET_GEO_REPORT_USAGE';